module.exports = __webpack_public_path__ + "static/media/carry01.82b3743a.png";